/**
 * This file is loading everything we use *a lot* in different Vue components
 * into the Vue prototype instance.
 *
 * If there is something that is used just once or very rare, then you're NOT
 * allowed to put it into this file! If you do so, you'll bloat the whole JS
 * frontend.
 */

// Vue Instance
import Vue from 'vue';

// Our app config / instance
import App from './App';

// Third Party Vue Stuff
import VModal from 'vue-js-modal';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import * as VeeValidationRules from 'vee-validate/dist/rules';
import * as VeeCustomValidationRules from 'PublicJs/VeeValidate/CustomRules';
import VeeLocalization from 'PublicJs/VeeValidate/Localization';
import VueI18Next from '@panter/vue-i18next';
import VueMoment from 'vue-moment';
import VueMultiselect from 'vue-multiselect';
import InputErrors from 'PublicJs/Components/Generic/InputErrors';

// Adding our App instance globally to vue
Vue.prototype.$App = App;
/*******************************************************************************
 * Filters
 ******************************************************************************/
import SecondDecimalFilter from './Filters/SecondDecimal';
import ImageUrlFilter from './Filters/ImageUrl';
import TruncateFilter from './Filters/Truncate';

Vue.filter('secondDecimal', SecondDecimalFilter);
Vue.filter('imageUrl', ImageUrlFilter);
Vue.filter('truncate', TruncateFilter)

/*******************************************************************************
 * Components
 ******************************************************************************/
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('Multiselect', VueMultiselect);
Vue.component('InputErrors', InputErrors);

/*******************************************************************************
 * Plugins
 ******************************************************************************/
Vue.use(VueMoment);
Vue.use(VueI18Next);
Vue.use(VModal);

/*******************************************************************************
 * I18n
 ******************************************************************************/
const i18n = new VueI18Next(window.i18next);

Vue.mixin({
	i18n,
	i18nOptions: { namespaces: 'translation' }
});

/*******************************************************************************
 * Vee Validate Config
 ******************************************************************************/
// Load all Vee-Validate Rules
Object.keys(VeeValidationRules).forEach(rule => {
	extend(rule, VeeValidationRules[rule]);
});

// Load our custom rules
Object.keys(VeeCustomValidationRules).forEach(rule => {
	extend(rule, VeeCustomValidationRules[rule]);
});

export default Vue;
